import {
  createCompanySubscriptionOrder,
  getCompanySubscriptionStatus,
  getCompanySubscriptionHistory,
  listSubscriptionPlans,
} from './backend';
import { safeExternalUrl } from '../../utils/safeNavigation';
import { listCompanyManualPayments } from './manualPayment';

export const getSubscriptionWorkspace = async (companyId) => {
  const [status, plansResult, historyResult, manualPayments] = await Promise.all([
    getCompanySubscriptionStatus(companyId),
    listSubscriptionPlans(false),
    getCompanySubscriptionHistory(companyId),
    listCompanyManualPayments(companyId).catch(() => []),
  ]);
  return {
    ...status,
    plans: plansResult?.plans || [],
    payments: historyResult?.payments || [],
    manualPayments: manualPayments || [],
    history: historyResult?.history || [],
  };
};

export const purchaseCompanyPlan = async ({ companyId, planId, onSuccess }) => {
  const order = await createCompanySubscriptionOrder(companyId, planId, window.location.origin);
  if (order?.free || order?.activated || order?.required === false) {
    onSuccess?.(order);
    return order;
  }
  if (!['stripe', 'revolut'].includes(order?.provider)) throw new Error('The configured payment provider is unavailable.');
  if (!order.checkoutUrl) throw new Error('The payment page could not be created. Please try again.');
  const checkoutUrl = safeExternalUrl(order.checkoutUrl, { allowBlob: false });
  if (!checkoutUrl) throw new Error('The payment provider returned an unsafe checkout URL.');
  window.location.assign(checkoutUrl);
  return { ...order, redirected: true };
};
